module.exports = "pegasus/assets/rad-back.png";